import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import TableContent from "../../table/table";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../Notifcation";
import {
  DeleteAttendenceAction,
  GetAllAttendenceAction,
} from "../../../../redux/actions/AttendenceActions";
import dayjs from "dayjs";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../Utility/Pagination/Pagination";
const Display = ({
  key,
  setKey,
  Datee,
  setDate,
  StatusAttende,
  setStatusAttende,
  time,
  settime,
  Day,
  setDay,
  empname,
  setempname,
  isEdit,
  setIsEdit,
  AttendenceId,
  setAttendenceId,
  EmployeesId,
  setEmployeesId,
  Note,
  setNote,
  setCreatedbyUserId,
  CreatedbyUserId,
  setEye,
  Eye,
}) => {
  const [Dateeto, setDateto] = useState("");
  const [Dateefrom, setDatefrom] = useState("");
  const [isPress, setIsPress] = useState(false);
  const [Searchkey, setSearchkey] = useState("");
  const [loading, setLoading] = useState(true);
  const PageSize = 7;
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setAttendenceId(itemid);
  };
  const onPress = async (page) => {
    await dispatch(
      GetAllAttendenceAction(`PageNumber=${page}&PageSize=${PageSize}`)
    );
  };

  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteAttendenceAction(AttendenceId));
    setLoading(false);
    setAttendenceId(null);
    setshowDelete(false);
    setIsPress(false);
  };
  const Update = (item) => {
    setKey("enter");
    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setStatusAttende(item.attendanceType);
    setDay(item.day);
    setNote(item.note);
    setAttendenceId(item.id);
    setDate(item.date.split("T")[0]);
    settime(dayjs(`1970-01-01T${item.time}`));
    setAttendenceId(item.id);
    setIsEdit(true);
    setEye(false);
  };
  const Showw = (item) => {
    setKey("enter");

    setEmployeesId({
      name: item.employeeName,
      id: item.employeeId,
    });
    setDay(item.day);
    setStatusAttende(item.attendanceType);
    setNote(item.note);
    setAttendenceId(item.id);
    setDate(item.date.split("T")[0]);
    settime(dayjs(`1970-01-01T${item.time}`));
    setAttendenceId(item.id);

    setIsEdit(false);
    setEye(true);
  };

  const All = useSelector((state) => state.AttendenceR.GetAttendence);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetAllAttendenceAction(
        `To=${Dateeto}&From=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  }, [Searchkey, Dateeto, Dateefrom]);
  const handleSubmit = async () => {
    await dispatch(
      GetAllAttendenceAction(
        `To=${Dateeto}&From=${Dateefrom}&SearchTerm=${Searchkey}&PageSize=${PageSize}`
      )
    );
  };

  const DEL = useSelector((state) => state.AttendenceR.DeleteAttendence);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, attendance deleted successfully"
          ) {
            dispatch(GetAllAttendenceAction(`PageSize=${PageSize}`));
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);

        // setLoading(true);
      }
    }
  }, [loading]);

  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <div className="dateee">
                {Dateefrom ? Dateefrom.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ من"
                variant="outlined"
                type="date"
                value={Dateefrom}
                onChange={(e) => setDatefrom(e.target.value)}
              />
            </div>
            <div className="inp-container">
              <div className="dateee">
                {Dateeto ? Dateeto.split("-").reverse().join("-") : null}
              </div>
              <i className="ty fa-solid fa-calendar-days"></i>
              <TextField
                label="التاريخ إلى"
                variant="outlined"
                type="date"
                value={Dateeto}
                onChange={(e) => setDateto(e.target.value)}
              />
            </div>
            <div className="inp-container ">
              {" "}
              <TextField
                label="ابحث"
                variant="outlined"
                value={Searchkey}
                onChange={(e) => setSearchkey(e.target.value)}
                //   className="ww"
              />
              <i
                className="ty fa-solid fa-magnifying-glass"
                onClick={handleSubmit}></i>
            </div>{" "}
            <div className="inp-container"></div>
          </div>
          <button className="buttonadd" onClick={handleSubmit}>
            بحث
          </button>
        </Container>
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                اسم الموظف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                التاريخ<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الوقت<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الحالة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ادخال / مراجعة <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ملاحظات <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {All && All.data && All.data.length > 0
              ? All.data.map((item, idx) => {
                  // ForceCount = ALL.TotalPages - 1;
                  return (
                    <tr key={idx} onDoubleClick={() => Update(item)}>
                      <td>{item.employeeName}</td>
                      <td>{new Date(item.date).toLocaleDateString("en-GB")}</td>
                      <td>{item.time}</td>
            <td>
                        {item.attendanceType === "Presence"
                          ? "حضور"
                          : item.attendanceType === "Departure"
                          ? "انصراف"
                          : ""}
                      </td>
                      <td>{item.createdByName}</td>
                      <td>{item.note}</td>
                      <td className="icon-w" onClick={() => Update(item)}>
                        <i
                          className="fa fa-solid fa-pen-to-square icon-blue"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        {" "}
                        <i
                          onClick={() => handleShoweDelete(item.id)}
                          className="fs fa-solid fa-trash-can icon-red"
                          style={{ color: "#333" }}></i>
                      </td>
                      <td className="icon-w">
                        <i
                          onClick={() => Showw(item)}
                          className="fa-solid fa-eye"
                          style={{ color: "#333" }}></i>
                      </td>
                    </tr>
                  );
                })
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
        <Pagination
          onPress={onPress}
          PageSize={PageSize}
          PageCount={All ? All.totalPages : null}
          // ForceCount={ForceCount}
          // itemsPerPage={2}
          // items={FilesDetails.data}
        />
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
                            <Modal.Title> </Modal.Title>
                          </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default Display;
